import { useCallback, useMemo, useState } from 'react';
import { theme } from 'antd';
import { useAuth } from "contexts/auth";
import useIsMobile from '@/hooks/useIsMobile';

const useIndex = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const isMobile = useIsMobile(992);
  const { user, logout } = useAuth();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const toggleCollapsed = useCallback(() => {
    setCollapsed((current) => !current);
  }, []);

  const openMenu = useCallback(() => {
    setShowMenu(true);
  }, []);

  const closeMenu = useCallback(() => {
    setShowMenu(false);
  }, []);

  const accountMenuClick = useCallback((e) => {
    if (e.key === "logout") {
      logout();
      return;
    }
  }, [logout]);

  const accountMenu = useMemo(() => ({
    items: [
      {
        key: 'logout',
        label: 'Đăng xuất',
      },
    ],
    onClick: accountMenuClick,
  }), [accountMenuClick]);

  return {
    collapsed,
    toggleCollapsed,
    user,
    colorBgContainer,
    borderRadiusLG,
    accountMenu,
    isMobile,
    showMenu,
    openMenu,
    closeMenu,
  };
};

export default useIndex;
